export default {
    measurePolyline: {
        group: 'measure',
        action: 'measure-polyline',
        label: 'Measure line'
    },
    measurePolygon: {
        group: 'measure',
        action: 'measure-polygon',
        label: 'Measure Area'
    },
    clearMeasure: {
        group: 'measure',
        action: 'clear-measure',
        label: 'Actions'
    },
    saveWorkspace: {
        group: 'workspace',
        action: 'save-workspace',
        label: 'Save Workspace'
    },
    loadWorkspace: {
        group: 'workspace',
        action: 'load-workspace',
        label: 'Load Workspace'
    },
    default: {
        group: 'default',
        action: 'default',
        label: 'Actions'
    }
};
